var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIssueAppCardDecoration = function SvgIssueAppCardDecoration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 12,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.046,
    cy: 5.612,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.239,
    cy: 1.403,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.149,
    cy: 9.821,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.866,
    cy: 5.612,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.059,
    cy: 1.403,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.969,
    cy: 9.821,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.686,
    cy: 5.612,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.882,
    cy: 1.403,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.79,
    cy: 9.821,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.403,
    cy: 5.612,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.506,
    cy: 9.821,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.223,
    cy: 5.612,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.419,
    cy: 1.403,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.329,
    cy: 9.821,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.954,
    cy: 5.612,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.149,
    cy: 1.403,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.059,
    cy: 9.821,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.776,
    cy: 5.612,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.969,
    cy: 1.403,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.882,
    cy: 9.821,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.313,
    cy: 5.612,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.506,
    cy: 1.403,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.419,
    cy: 9.821,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.598,
    cy: 5.612,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.79,
    cy: 1.403,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.134,
    cy: 5.612,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.329,
    cy: 1.403,
    r: 1.403,
    fill: "#DDD9FF"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.239,
    cy: 9.821,
    r: 1.403,
    fill: "#DDD9FF"
  })));
};
export default SvgIssueAppCardDecoration;